import React, {Component} from 'react'
import banner5 from "../../img/banner_home_big5-min.jpg";
import strings from "../../strings/localeStrings";
import {Button} from "react-bootstrap";
import banner from "../../img/banner_home_big-min.jpg";
import AdminService from "../../admin/adminComponents/AdminService";

export default class Slider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
        }
    }

    componentWillMount() {
        AdminService.getSlider()
            .then(function (response) {
                response.data.sort((a, b) => (a.tytul > b.tytul) ? 1 : -1)
                this.setState({data: response.data, loading: false})
            }.bind(this)).catch((e) => {
            console.log(e)
        })
    }

    render() {
        return <div className="text-center">
            {this.state.loading ? <div>
                <div className="loaderDim loaderDim-slider" style={{textAlign: 'center', paddingBottom: 350}}><i
                    className="fa fa-spinner fa-pulse fa-2x fa-fw"
                    style={{
                        color: '#58b13d'
                    }}> </i></div>
            </div> : <div>
                {this.state.data.length === 0 ?
                    <div id="carouselHome" className="carousel slide" data-ride="carousel" data-interval="4000">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img className="d-block w-100" src={banner5} alt="First slide"/>
                                <div className="caption">
                                    <p>{strings.przykladowyTekst} <font color="#8dc846">{strings.wyszukiwarka}</font>
                                    </p>
                                    <Button bsStyle={'success'}
                                            style={{fontSize: '1rem', boxShadow: '2px 2px 3px #000000aa'}}>Sprawdź
                                        aktualne położenie busów</Button>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <img className="d-block w-100" src={banner} alt="Second slide"/>
                                <div className="caption">
                                    <p>{strings.przykladowyTekst} <font color="#8dc846">{strings.wyszukiwarka}</font>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <a className="carousel-control-prev" href="#carouselHome" data-slide="prev">
                            <span className="carousel-control-prev-icon"></span>
                        </a>
                        <a className="carousel-control-next" href="#carouselHome" data-slide="next">
                            <span className="carousel-control-next-icon"></span>
                        </a>
                    </div>
                    :
                    <div id="carouselHome" className="carousel slide" data-ride="carousel" data-interval="4000">
                        {this.state.data.length !== 0 ? <div className="carousel-inner">
                            {this.state.data.map((item, index) => {
                                if (!item.opublikowano) {
                                }
                                if (index === 0) {
                                    return <div className="carousel-item active">
                                        <img className="d-block w-100"
                                             src={'data:' + item.pliki[0].typ + ';base64, ' + item.pliki[0].dane}
                                             alt="Slajd główny"/>
                                        <div className="caption">
                                            <p dangerouslySetInnerHTML={{__html: item.tresc}}></p>
                                        </div>
                                    </div>
                                } else {
                                    return <div className="carousel-item">
                                        <img className="d-block w-100"
                                             src={'data:' + item.pliki[0].typ + ';base64, ' + item.pliki[0].dane}
                                             alt="Slajd"/>
                                        <div className="caption">
                                            <p dangerouslySetInnerHTML={{__html: item.tresc}}></p>
                                        </div>
                                    </div>
                                }
                            })}
                        </div> :
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img className="d-block w-100"
                                         src={banner5}
                                         alt="Slajd główny"/>
                                    <div className="caption">
                                        <p>Witaj na stronie Marcel Bus!</p>
                                    </div>
                                </div>
                            </div>}
                        <a className="carousel-control-prev" href="#carouselHome" data-slide="prev">
                            <span className="carousel-control-prev-icon"></span>
                        </a>
                        <a className="carousel-control-next" href="#carouselHome" data-slide="next">
                            <span className="carousel-control-next-icon"></span>
                        </a>
                    </div>
                }</div>}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Slider.js